var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "persistent": !_vm.timer,
      "max-width": _vm.dialogMaxWidth,
      "content-class": _vm.contentClass,
      "transition": "dialog-transition"
    },
    on: {
      "input": _vm.onInput
    }
  }, [_c('v-card', {
    staticClass: "swal-dialog-card",
    "class": {
      'swal-dialog-card--toast': _vm.toast
    }
  }, [!_vm.toast ? _c('div', {
    staticClass: "swal-dialog-header",
    "class": "swal-dialog-header--".concat(_vm.type)
  }, [_vm.showCloseButton ? _c('v-btn', {
    staticClass: "swal-dialog-close",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _c('div', {
    staticClass: "swal-dialog-header__content"
  }, [_vm.typeIcon ? _c('div', {
    staticClass: "swal-dialog-icon-badge",
    "class": "swal-dialog-icon-badge--".concat(_vm.type)
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.typeColor,
      "small": _vm.toast
    }
  }, [_vm._v(" " + _vm._s(_vm.typeIcon) + " ")])], 1) : _vm._e(), _c('span', {
    staticClass: "swal-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))])])], 1) : _c('v-card-title', {
    staticClass: "d-flex align-center py-2"
  }, [_vm.typeIcon ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.typeColor,
      "left": "",
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.typeIcon) + " ")]) : _vm._e(), _c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.title))]), _c('v-spacer'), _vm.showCloseButton ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _vm._e()], 1), _c('v-card-text', {
    "class": _vm.toast ? 'pt-0 pb-2' : 'pt-6 pb-7 px-5'
  }, [_vm.html ? _c('div', {
    staticClass: "swal-dialog-body",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }) : _vm.text ? _c('div', {
    staticClass: "swal-dialog-body"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]) : _vm._e(), _vm.input === 'select' ? _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "value": _vm.inputValue,
      "items": _vm.selectOptions,
      "label": _vm.inputPlaceholder,
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.setInputValue
    }
  }) : _vm.input === 'textarea' ? _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "value": _vm.inputValue,
      "placeholder": _vm.inputPlaceholder,
      "outlined": "",
      "dense": "",
      "rows": "4",
      "hide-details": ""
    },
    on: {
      "input": _vm.setInputValue
    }
  }) : _vm.input === 'text' ? _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "value": _vm.inputValue,
      "placeholder": _vm.inputPlaceholder,
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.setInputValue
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "swal-dialog-actions",
    "class": [_vm.toast ? 'px-4 pt-0 pb-2 mt-0' : 'px-4 pt-2 pb-3 mt-0 swal-dialog-actions--standard']
  }, [_vm.showCancelButton ? _c('v-btn', {
    staticClass: "swal-dialog-action-btn swal-dialog-action-btn--secondary",
    attrs: {
      "outlined": "",
      "color": "grey darken-1",
      "disabled": _vm.confirmLoading
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelButtonText) + " ")]) : _vm._e(), _vm.showCloseButton && !_vm.showCancelButton ? _c('v-btn', {
    staticClass: "swal-dialog-action-btn swal-dialog-action-btn--secondary",
    attrs: {
      "outlined": "",
      "color": "grey darken-1",
      "disabled": _vm.confirmLoading
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(" " + _vm._s(_vm.closeButtonText) + " ")]) : _vm._e(), _vm.showDenyButton ? _c('v-btn', {
    staticClass: "swal-dialog-action-btn swal-dialog-action-btn--secondary",
    attrs: {
      "outlined": "",
      "color": "grey darken-1",
      "disabled": _vm.confirmLoading
    },
    on: {
      "click": _vm.onDeny
    }
  }, [_vm._v(" " + _vm._s(_vm.denyButtonText) + " ")]) : _vm._e(), _c('v-btn', {
    staticClass: "swal-dialog-action-btn swal-dialog-action-btn--primary",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.confirmLoading,
      "disabled": _vm.confirmLoading || !_vm.validSelection
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmButtonText) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }